import React, { useContext, useEffect, useState } from 'react';
import { IoIosArrowDropupCircle } from 'react-icons/io';

import { ThemeContext } from '../../contexts/ThemeContext';
import './BackToTop.css';

function BackToTop() {
    const [visible, setVisible] = useState(false);

    const { theme } = useContext(ThemeContext);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            setVisible(scrolled > 300);
        };

        window.addEventListener('scroll', toggleVisible, { passive: true });
        toggleVisible();
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);

    return (
        <div
            style={{ display: visible ? 'inline' : 'none' }}
            className='backToTop'
        >
            <button onClick={scrollToTop} aria-label='Back to top'>
                <IoIosArrowDropupCircle style={{ color: theme.tertiary, fontSize: '3rem' }} />
            </button>
        </div>
    );
}

export default BackToTop;
